module.exports = "/static/assets/7ca82ca6ee18a4c008cae2b4fc8d5be2.gif";